import { ErrorState, LoadingState } from '@ca/core/models';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from './machine-learning.actions';
import { initialMachineLearningState, MachineLearningState } from './machine-learning.state';

const machineLearningReducer = createReducer(
    initialMachineLearningState,
    on(actions.loadSegmentationWorkflows, state => ({ ...state, loading: true })),
    on(actions.loadSegmentationWorkflowsSuccess, (state, action) => ({ ...state, segmentationWorkflows: action.segmentationWorkflows })),
    on(actions.loadSegmentationWorkflowsFailed, (state, action) => ({ ...state, segmentationWorkflows: [], error: action.error })),
    on(actions.loadTrainingWorkflows, state => ({ ...state, loading: true })),
    on(actions.loadTrainingWorkflowsSuccess, (state, action) => ({ ...state, trainingWorkflows: action.trainingWorkflows })),
    on(actions.loadTrainingWorkflowsFailed, (state, action) => ({ ...state, trainingWorkflows: [], error: action.error })),
    on(actions.loadDatasets, state => ({ ...state, datasetCallState: LoadingState.LOADING, numberOfAllDatasetsCallState: LoadingState.LOADING })),
    on(actions.loadDatasetsSuccess, (state, action) => ({
        ...state,
        datasets: action.datasets,
        totalCount: action.totalCount,
        datasetCallState: LoadingState.LOADED,
    })),
    on(actions.loadDatasetsFailed, (state, action) => ({ ...state, datasets: [], datasetCallState: { errorMsg: action.errorMsg } as ErrorState })),
    on(actions.loadNumberOfAllDatasets, state => ({ ...state, numberOfAllDatasetsCallState: LoadingState.LOADING })),
    on(actions.loadNumberOfAllDatasetsSuccess, (state, action) => ({
        ...state,
        numberOfAllDatasets: action.numberOfAllDatasets,
        numberOfAllDatasetsCallState: LoadingState.LOADED,
    })),
    on(actions.loadNumberOfAllDatasetsFailed, (state, action) => ({
        ...state,
        numberOfAllDatasetsCallState: { errorMsg: action.errorMsg } as ErrorState,
    })),
);

export function reducer(state: MachineLearningState | undefined, action: Action) {
    return machineLearningReducer(state, action);
}
